import { motion } from "framer-motion";
import { Zap, ShieldCheck } from "lucide-react";
import { CT_IMAGES } from "@/cleanteamData";

const EASE = [0.22, 1, 0.36, 1];

export default function CleanTeamHero() {
  return (
    <section id="top" className="relative min-h-[92vh] flex items-center overflow-hidden bg-[#07090E]" data-testid="ct-hero">
      <img src={CT_IMAGES.hero} alt="Football stadium under the lights" className="absolute inset-0 w-full h-full object-cover opacity-50" data-testid="ct-hero-image" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#07090E]/70 via-[#07090E]/40 to-[#07090E]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#07090E]/70 via-transparent to-transparent" />

      <div className="relative z-10 w-full px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-24 md:py-32">
        <motion.span
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1, ease: EASE }}
          className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#39FF14] border border-[#39FF14]/30 bg-[#39FF14]/10 backdrop-blur-md px-4 py-2 rounded-full mb-8"
          data-testid="ct-hero-badge">
          <Zap size={14} /> All 32 Teams · Game-Day Ready
        </motion.span>

        <h1 className="font-['Barlow_Condensed',sans-serif] text-6xl sm:text-7xl lg:text-8xl font-black uppercase tracking-tight leading-[0.95] text-white" data-testid="ct-hero-title">
          <span className="block overflow-hidden pb-1">
            <motion.span className="block" initial={{ y: "112%" }} animate={{ y: "0%" }} transition={{ duration: 1, delay: 0.25, ease: EASE }}>
              Every Team.
            </motion.span>
          </span>
          <span className="block overflow-hidden pb-1">
            <motion.span className="block" initial={{ y: "112%" }} animate={{ y: "0%" }} transition={{ duration: 1, delay: 0.39, ease: EASE }}>
              Every <span className="text-[#39FF14]">Sunday.</span>
            </motion.span>
          </span>
          <span className="block overflow-hidden pb-2">
            <motion.span className="block" initial={{ y: "112%" }} animate={{ y: "0%" }} transition={{ duration: 1, delay: 0.53, ease: EASE }}>
              One <span className="text-[#FFD700]">Clean</span> Look.
            </motion.span>
          </span>
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.8, ease: EASE }}
          className="mt-7 text-base md:text-lg leading-relaxed text-white/70 max-w-xl" data-testid="ct-hero-subtitle">
          Premium stitched jerseys for all 32 NFL teams. Pick your team, pick your size, and rep your colors on game day. Dispatched in 2 days.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.95, ease: EASE }}
          className="mt-9 flex flex-wrap gap-4">
          <a href="#teams" data-testid="ct-hero-shop-btn"
            className="inline-flex items-center gap-2 bg-[#39FF14] text-[#07090E] font-bold uppercase tracking-wider px-8 py-4 rounded-full hover:bg-[#5CFF3D] hover:-translate-y-0.5 transition-all duration-300 shadow-[0_10px_40px_-10px_rgba(57,255,20,0.5)]">
            Shop All 32 Teams
          </a>
          <a href="#quality" data-testid="ct-hero-quality-btn"
            className="inline-flex items-center gap-2 border border-white/25 text-white font-bold uppercase tracking-wider px-8 py-4 rounded-full backdrop-blur-md bg-white/5 hover:bg-white/15 transition-all duration-300">
            <ShieldCheck size={18} /> Stitch Quality
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.1, ease: EASE }}
          className="mt-14 flex gap-8 sm:gap-12 text-sm text-white/50 border-t border-white/10 pt-7 max-w-xl" data-testid="ct-hero-stats">
          <div><span className="font-['Barlow_Condensed',sans-serif] text-3xl md:text-4xl font-extrabold text-white block">32</span>NFL Teams</div>
          <div><span className="font-['Barlow_Condensed',sans-serif] text-3xl md:text-4xl font-extrabold text-white block">5★</span>Fan Rated</div>
          <div><span className="font-['Barlow_Condensed',sans-serif] text-3xl md:text-4xl font-extrabold text-white block">2-Day</span>Dispatch</div>
        </motion.div>
      </div>
    </section>
  );
}
